import { getYoutubeThumbnailUrl } from './getYoutubeThumbnailUrl';

export const getHeaderImage = (
  imageURL?: string | null,
  videoURL?: string | null,
  highQuality?: boolean,
) => {
  return imageURL || getYoutubeThumbnailUrl(videoURL, highQuality);
};
